var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 12.4545C1.75 6.57509 6.75353 1.75 13 1.75C19.2465 1.75 24.25 6.57509 24.25 12.4545C24.25 18.334 19.2465 23.1591 13 23.1591C6.75353 23.1591 1.75 18.334 1.75 12.4545ZM13 0.25C5.99163 0.25 0.25 5.68166 0.25 12.4545C0.25 19.2274 5.99163 24.6591 13 24.6591C20.0084 24.6591 25.75 19.2274 25.75 12.4545C25.75 5.68166 20.0084 0.25 13 0.25ZM19.5887 9.0889C19.8883 8.8029 19.8994 8.32815 19.6134 8.02853C19.3274 7.72891 18.8526 7.71787 18.553 8.00387L10.3986 15.7876L7.44754 12.9707C7.14792 12.6847 6.67318 12.6958 6.38717 12.9954C6.10117 13.295 6.11221 13.7697 6.41183 14.0557L9.88074 17.367C10.1706 17.6436 10.6266 17.6436 10.9165 17.367L19.5887 9.0889Z",
    fill: "#00A63B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.87c240ee7ec2a52de7a895dfd7bfd581.svg";
export { ForwardRef as ReactComponent };